import { resolveLocalizedName, type LocalizedNameMap } from 'pi-kiosk-shared';

/**
 * Resolve sales-point description for active UI language.
 * Fallback order: localized override -> universal description -> empty string.
 */
export function resolveSalesPointDescription(
  description: string | null | undefined,
  descriptionLocales: LocalizedNameMap | null | undefined,
  language: string,
): string {
  const universal = typeof description === 'string' ? description : '';
  return resolveLocalizedName(universal, descriptionLocales ?? null, language);
}
